import Icon from 'antd-mobile/lib/icon';
export default Icon;



// WEBPACK FOOTER //
// ./components/icon/index.tsx